import { ErrorState, Skeleton } from "@/components/ui/states";
import styles from "./workspace-frame.module.css";

export function WorkspaceLoading({ label = "İçerik yükleniyor", lines = 7 }: { label?: string; lines?: number }) {
  return (
    <main className={`page ${styles.workspace}`} data-workspace-state="loading">
      <Skeleton lines={lines} label={label} />
    </main>
  );
}

export function WorkspaceError({ title, description, onRetry }: { title: string; description?: string; onRetry?: () => void }) {
  return (
    <main className={`page ${styles.workspace}`} data-workspace-state="error">
      <ErrorState title={title} description={description} onRetry={onRetry} />
    </main>
  );
}
